var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBondWedgeBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 100 100",
    fill: "#000000",
    strokeLinecap: "round",
    strokeWidth: 6,
    stroke: "#000000",
    transform: "rotate(-45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: "10%",
    y1: "46%",
    x2: "10%",
    y2: "52%"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: "20%",
    y1: "44%",
    x2: "20%",
    y2: "54%"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: "30%",
    y1: "42%",
    x2: "30%",
    y2: "56%"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: "40%",
    y1: "40%",
    x2: "40%",
    y2: "58%"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: "50%",
    y1: "38%",
    x2: "50%",
    y2: "60%"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: "60%",
    y1: "36%",
    x2: "60%",
    y2: "62%"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: "70%",
    y1: "34%",
    x2: "70%",
    y2: "64%"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: "80%",
    y1: "32%",
    x2: "80%",
    y2: "68%"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: "90%",
    y1: "30%",
    x2: "90%",
    y2: "70%"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBondWedgeBack);
export default __webpack_public_path__ + "static/media/bond_wedge_back.af72e68b5c3f59e445a44d70086f6860.svg";
export { ForwardRef as ReactComponent };